import {appUrl} from '@frontend/AppUrl'
import {InlineErrorBoundary} from '@frontend/components/InlineErrorBoundary'
import {trans} from '@frontend/helpers'
import {useUserData} from '@frontend/hooks'
import {useIsMobileScreen} from '@frontend/hooks/useIsMobileScreen'
import {
    useAccountFlagsStore,
    useMiniChatStore,
} from '@frontend/stores'
import {mdiChevronUp} from '@mdi/js'
import clsx from 'clsx'
import {useMatch} from 'react-router-dom'
import {FadeIn} from 'swayok-react-mdb-ui-kit/components/Animation/FadeIn'
import {Card} from 'swayok-react-mdb-ui-kit/components/Card/Card'
import {CardBody} from 'swayok-react-mdb-ui-kit/components/Card/CardBody'
import {CardHeader} from 'swayok-react-mdb-ui-kit/components/Card/CardHeader'
import {CardTitle} from 'swayok-react-mdb-ui-kit/components/Card/CardTitle'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {Badge} from 'swayok-react-mdb-ui-kit/components/Typography/Badge'
import {ChatsPageContent} from './ChatsPageContent'

// Мини-чат.
export function MiniChat() {

    const user = useUserData()
    const miniChatStore = useMiniChatStore()
    const isMobile = useIsMobileScreen()
    const hasNewChatMessages = useAccountFlagsStore(
        state => state.hasNewChatMessages
    )

    // Является ли текущая страница чатом или списком чатов?
    const chatsUrlMatch = useMatch(appUrl().cabinet.chats.index)

    // Видимость чата.
    const visible: boolean = (
        miniChatStore.visible
        && !!user?.registeredAt
        && !isMobile
        && !chatsUrlMatch
    )

    return (
        <FadeIn visible={visible}>
            <Card
                id="mini-chat"
                className={clsx(
                    'shadow-2-strong',
                    miniChatStore.expanded ? 'open' : null
                )}
            >
                <CardHeader
                    className="flex-row-between cursor"
                    onClick={() => {
                        miniChatStore.toggleExpanded()
                    }}
                >
                    <CardTitle className="position-relative fs-6">
                        {trans().cabinet.chats.mini_chat.header}
                        {hasNewChatMessages && (
                            <Badge
                                dot
                                color="red"
                                className="ms-0"
                            />
                        )}
                    </CardTitle>
                    <Icon
                        path={mdiChevronUp}
                        rotate={miniChatStore.expanded ? 180 : 0}
                        className="flex-shrink-0 ms-3"
                    />
                </CardHeader>
                <div className="card-body-container">
                    <CardBody className="p-0">
                        <InlineErrorBoundary>
                            <ChatsPageContent
                                miniChat
                                selectedChatId={miniChatStore.activeChatId}
                                resetSelectedChatProp={() => {
                                    miniChatStore.setActiveChatId(null)
                                }}
                            />
                        </InlineErrorBoundary>
                    </CardBody>
                </div>
            </Card>
        </FadeIn>
    )
}
